/**
 * Generates a srcSet string for responsive images with 1x, 2x, and 3x pixel densities.
 *
 * @example
 * ```tsx
 * import icon from "./icon.webp";
 * import icon2x from "./icon@2x.webp";
 * import icon3x from "./icon@3x.webp";
 *
 * <img src={icon} srcSet={srcSet(icon, icon2x, icon3x)} alt="Icon" />
 * ```
 */
export const srcSet = (x1: string, x2: string, x3: string): string => `${x1} 1x, ${x2} 2x, ${x3} 3x`;
